import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const GridRowCardByRowContainer = styled.div`
  width: 100%;
  display: flex;
  background: ${colors.white};
  border-radius: 18px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  
  & + & {
    margin-top: 15px;
  }
`;

export const GridRowCardFooterButton = styled.button`
  width: 24px;
  height: 24px;
  border: 1px solid ${colors.green};
  background: ${colors.gamerGray};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 12px;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;
  float:right;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
  -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const GridRowCardByRowItem = styled.div`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: column;
  padding: 20px 0px 20px 15px;

  &:last-child {
    padding-right: 15px;
    align-items: flex-end;
  }

  &:nth-child(1) {
    min-width: 230px;
  }

  &:nth-child(2) {
    min-width: 125px;
  }

  &:nth-child(3) {
    min-width: 140px;
  }

  &:nth-child(4) {
    min-width: 150px;
  }

  &:nth-child(7) {
    max-width: 40px;
  }
`;

export const GridRowCardByRowStrong = styled.strong`
  color: ${colors.textPrimary};
  font-size: 12px;
  font-weight: 700;
  line-height: 17px;
`;

export const GridRowCardByRowLabel = styled.span`
  font-size: 12px;
  color: ${colors.textSecondary};
  line-height: 17px;

  &:last-child {
    flex: 1;
  }
`;

export const GridRowCardByRowValue = styled.span`
  font-size: 12px;
  color: ${colors.textPrimary};
  line-height: 17px;

  strong {
    font-weight: bold;
    color: ${colors.textPrimary};
  }
`;

export const GridRowCardByRowButton = styled.button`
  width: 24px;
  height: 24px;
  border: 1px solid ${colors.textSecondary};
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 12px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
  -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const AnularFooterButton = styled.span`
  margin-top: 70px;
  text-decoration: underline;
  color: ${colors.textHyperlink};
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: .2s;

  &:hover {
    color: ${colors.bgSecondaryHover};
  }
`;